var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('vue-snotify'),_c('Navbar'),_c('div',{staticClass:"py-5 position-relative",staticStyle:{"min-height":"calc(100% - 148px)"},attrs:{"id":"app"}},[_c('RouterView')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }